'use client';

import { Containers, Widgets } from '@/components';

export default function ContactUsPage() {
    return <Containers.Section el={<Widgets.ContactUs />} />;
}
